// overlay.js
import { Events } from "./events.js";
import { PerformanceMonitor } from "./performance.js";
import { ConnectionQuality } from "./connection.js";
import { Live } from "./live.js";

export const Overlay = {
    _scrolls: 0,

    bind(dotNetRef) {
        Events.on("prof:updated", stats => {
            this._scrolls = stats.scrolls;
        });

        setInterval(() => {
            const now = Date.now();

            const data = {
                AvgLiveToUi: PerformanceMonitor.getAverageLiveToUi(),
                EventsPerMinute: PerformanceMonitor._metrics.eventsPerMinute,
                ScrollsPerMinute: this._scrolls,
                ConnectionQuality: ConnectionQuality.getQuality(),
                HeartbeatAge: Live._lastHeartbeat ? now - Live._lastHeartbeat : 0,
                ReconnectAttempts: Live._reconnectAttempts,
                SignalRState: Live._connection ? Live._connection.state : "none"
            };

            dotNetRef.invokeMethodAsync("UpdateOverlay", data);
        }, 500);
    }
};
